/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_WebsiteInputs */

const cs_nav_website = /** @type {(inputs: Nav_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na web`)
};

const en_nav_website = /** @type {(inputs: Nav_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website`)
};

/**
* | output |
* | --- |
* | "Website" |
*
* @param {Nav_WebsiteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_website = /** @type {((inputs?: Nav_WebsiteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_WebsiteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_website(inputs)
	return cs_nav_website(inputs)
});